import React from 'react';

import ApplePaySmall from '~/assets/icons/ApplePaySmall';
import CreditCardIcon from '~/assets/icons/CreditCard';
import Gpay from '~/assets/icons/Gpay';
import HandlingCoinsIcon from '~/assets/icons/HandlingCoinsIcon';
import Maestro from '~/assets/icons/Maestro';
import MasterCard from '~/assets/icons/MasterCard';
import ShippingIcon from '~/assets/icons/Shipping';
import SoleMarketplaceLogo from '~/assets/icons/SoleMarketplaceLogo';
import TickIcon from '~/assets/icons/Tick';
import Visa from '~/assets/icons/Visa';

type Theme = 'dark' | 'light';

const getCardData = (iconFill: string, hideReturnsPolicy: boolean) => {
  const cards = [
    {
      description:
        'Our community of sellers are fully verified and we legit check each pair fast & effectively.',
      icon: <TickIcon fill={iconFill} height="16px" width="16px" />,
      title: 'Legit sellers & sneakers'
    },
    {
      description:
        'Orders are typically delivered in 2-4 working days. A shipping fee of £7.99 and a payment processing fee of 3% applies.',
      icon: <ShippingIcon fill={iconFill} height="16px" width="16px" />,
      title: 'Fast delivery & transparent costs'
    },
    {
      description: (
        <>
          <span>We accept most major cards.</span>
          <div className="flex gap-2 py-2">
            <ApplePaySmall />
            <Gpay />
            <Maestro />
            <MasterCard />
            <Visa />
          </div>
        </>
      ),
      icon: <CreditCardIcon stroke={iconFill} height={16} width={16} />,
      title: 'Flexible ways to pay'
    }
  ];

  if (!hideReturnsPolicy)
    cards.splice(2, 0, {
      description:
        'If your order doesn’t arrive exactly as advertised you will be entitled to a refund.',
      icon: <HandlingCoinsIcon fill={iconFill} height="16px" width="16px" />,
      title: 'Shop with confidence'
    });

  return cards;
};

type SoleMarketInfoCardProps = {
  description: React.ReactNode;
  icon: React.ReactNode;
  theme: Theme;
  title: string;
};

const SoleMarketInfoCard = ({
  title,
  description,
  icon,
  theme
}: SoleMarketInfoCardProps) => {
  const bgc = theme === 'dark' ? 'bg-dark-mode-black' : 'bg-grey-panel';
  const tc = theme === 'dark' ? 'text-white' : 'text-black';

  return (
    <div className={`flex flex-col rounded-lg p-4 ${bgc} ${tc}`}>
      <span className="inline-flex items-center justify-start gap-2 text-sm font-bold">
        {icon}
        {title}
      </span>
      <span className="text-sm">{description}</span>
    </div>
  );
};

const SoleMarketUsp = ({
  theme = 'dark',
  hideReturnsPolicy = false
}: {
  hideReturnsPolicy?: boolean;
  theme?: Theme;
}) => {
  const bgc = theme === 'dark' ? 'bg-dark-background' : 'bg-concrete';
  const tc = theme === 'dark' ? 'text-white' : 'text-black';
  const fill = theme === 'dark' ? '#FFFFFF' : '#000000';

  const cardData = getCardData(fill, hideReturnsPolicy);

  return (
    <div
      className={`flex flex-col justify-center gap-4 rounded-lg px-4 py-6 ${bgc} ${tc}`}
    >
      <div>
        <SoleMarketplaceLogo fill={fill} height="24" />
      </div>
      <div className="flex flex-col gap-2">
        {cardData.map(({ title, description, icon }, index) => (
          <SoleMarketInfoCard
            key={index}
            title={title}
            description={description}
            icon={icon}
            theme={theme}
          />
        ))}
      </div>
    </div>
  );
};

export default SoleMarketUsp;
